import React, { useState, useEffect } from "react";
import "../../styles/Hero/Hero.scss";
import Myself from "../../assets/images/myself.png";
import Myself_Light from "../../assets/images/light2.jpg";

const Hero = ({ darkTheme }) => {
  const [isKnowMoreHovered, setIsKnowMoreHovered] = useState(false);
  const [isContactHovered, setIsContactHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const alphabets = document.getElementsByClassName("hero__alphabet");
    for (let i = 0; i < alphabets.length; i++) {
      alphabets[i].addEventListener("animationend", function () {
        alphabets[i].classList.remove("alphabet-animated");
      });

      alphabets[i].addEventListener("mouseover", function () {
        alphabets[i].classList.add("alphabet-animated");
      });
    }
  }, []);

  return (
    <div className={`hero ${darkTheme ? "dark" : "light"}`}>
      <div className="hero__container">
        <div className="hero__intro-box">
          <p
            className="hero__intro-title"
            style={{ color: darkTheme ? "white" : "black" }}
          >
            <span
              className="hero__intro-line"
              data-aos="fade-down"
              style={{
                backgroundColor: darkTheme ? "#00ffff" : "#ff6347",
              }}
            ></span>
            HELLO, I AM MOHD. AQUIB
          </p>
          <p className="hero__animated-alphabet-box">
            <span
              className="hero__alphabet"
              data-aos="fade-up"
              data-aos-delay="200"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              D
            </span>
            <span
              className="hero__alphabet"
              data-aos="fade-up"
              data-aos-delay="400"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              A
            </span>
            <span
              className="hero__alphabet"
              data-aos="fade-up"
              data-aos-delay="600"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              T
            </span>
            <span
              className="hero__alphabet hero__alphabet--last"
              data-aos="fade-up"
              data-aos-delay="800"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              A
            </span>
            <span
              className="hero__developer-text"
              data-aos="zoom-out-down"
              data-aos-delay="1000"
            >
              <span className="hero__dev-text gradient-text">SCIENTIST</span>
            </span>
          </p>
          <div
            className="hero__description"
            data-aos="fade"
            data-aos-delay="1200"
            style={{ color: darkTheme ? "white" : "black" }}
          >
            <p>
              Unlocking the secrets of data for over 4 years, I'm a seasoned
              data scientist who thrives on transforming raw numbers into
              actionable insights. From unraveling patterns to predicting
              trends, I wield algorithms and analytics to navigate the data
              maze. With a passion for problem-solving and a knack for
              innovation, I'm ready to turn your data into gold.
            </p>
          </div>

          <div className="hero__buttons">
            <a
              className="hero__know-btn"
              href="#about"
              data-aos="fade-up"
              data-aos-delay="1800"
              onMouseEnter={() => setIsKnowMoreHovered(true)}
              onMouseLeave={() => setIsKnowMoreHovered(false)}
              style={{
                color: "black",
                background: isKnowMoreHovered
                  ? darkTheme
                    ? "#009999"
                    : "#ff4500"
                  : darkTheme
                  ? "#00ffff"
                  : "#ff6347",
                borderColor: isKnowMoreHovered
                  ? darkTheme
                    ? "#009999"
                    : "#ff4500"
                  : darkTheme
                  ? "#00ffff"
                  : "#ff6347",
              }}
            >
              Know more
            </a>
            <a
              className="hero__contact-btn"
              href="#contact"
              data-aos="fade-up"
              data-aos-delay="2000"
              onMouseEnter={() => setIsContactHovered(true)}
              onMouseLeave={() => setIsContactHovered(false)}
              style={{
                color: darkTheme ? "black" : "black",
                background: isContactHovered
                  ? darkTheme
                    ? "#009999"
                    : "#ff4500"
                  : darkTheme
                  ? "#00ffff"
                  : "#ff6347",
                borderColor: isContactHovered
                  ? darkTheme
                    ? "#009999"
                    : "#ff4500"
                  : darkTheme
                  ? "#00ffff"
                  : "#ff6347",
              }}
            >
              Contact me
            </a>
          </div>
        </div>
        <div
          className="hero__image"
          data-aos="zoom-in"
          data-aos-delay="200"
          style={{
            display: isMobile ? "none" : "block",
            height: "800px",
            width: "500px",
            marginRight: "100px",
            marginTop: "200px",
          }}
        >
          {darkTheme ? (
            <img src={Myself} alt="me" />
          ) : (
            <img src={Myself_Light} alt="me" />
          )}
        </div>
      </div>
    </div>
  );
};

export default Hero;
